import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
const is = require("is_js");

// 1. Import the functions
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

const signals = require("signals");

let _singleton = null;

class Virtualscrollbar {
  constructor(data) {
    if (!_singleton) {
      this.data = data;
      _singleton = this;
      this._init(data);
    } else {
      return _singleton;
    }
  }

  // eventos = {
  //   SCROLL_RENDER: new signals.Signal()
  // };

  bindedMethods = {
    // onVirtualScroll: this._onVirtualScroll.bind(this),
    // onRender: this.render.bind(this)
  };

  _init() {
    this.isLocked = false;

    //selecciona el elemento que hace scroll
    this.$el = document.documentElement;
    if (is.desktop() && is.safari()) {
      this.$el = document.body;
    }
  }

  scrollTo(newPos) {
    let eComplete = new signals.Signal();
    gsap.to(window, {
      duration: 0.65,
      scrollTo: {
        y: newPos,
        autoKill: false
      },
      onComplete: e => {eComplete.dispatch();}
    });
    return eComplete;
  }

  resize() {}

  lock(b) {
    this.isLocked = b;
    if (this.isLocked) {
      disableBodyScroll(this.el);
    } else {
      enableBodyScroll(this.el);
    }
  }
}

export default Virtualscrollbar;
